var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdminMemos({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.98555 4.08L6.55555 2.65C4.15555 4.48 2.57555 7.3 2.43555 10.5H4.43555C4.58555 7.85 5.94555 5.53 7.98555 4.08ZM20.3755 10.5H22.3755C22.2255 7.3 20.6455 4.48 18.2555 2.65L16.8355 4.08C18.8555 5.53 20.2255 7.85 20.3755 10.5ZM18.4055 11C18.4055 7.93 16.7655 5.36 13.9055 4.68V4C13.9055 3.17 13.2355 2.5 12.4055 2.5C11.5755 2.5 10.9055 3.17 10.9055 4V4.68C8.03555 5.36 6.40555 7.92 6.40555 11V16L4.40555 18V19H20.4055V18L18.4055 16V11ZM12.4055 22C12.5455 22 12.6755 21.99 12.8055 21.96C13.4555 21.82 13.9855 21.38 14.2455 20.78C14.3455 20.54 14.3955 20.28 14.3955 20H10.3955C10.4055 21.1 11.2955 22 12.4055 22Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminMemos);
export default __webpack_public_path__ + "static/media/adminMemos.b1ffa03d422a436ca68e606fc3fd26dd.svg";
export { ForwardRef as ReactComponent };